/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Höger till vänster",
		"timeZoneID": "Tidszon",
		"skin": "Format",
		"metricsFileImportTask": "Ny import från Filer",
		"displayMode": "Standardvy",
		"credentialRenewed": "Kreditiven förnyades med ditt aktuella användar-ID och lösenord.",
		"productLocale": "Produktspråk",
		"toggleDisabled": "av",
		"credentialChange": "Förnya",
		"log_level_Debug": "Felsökning",
		"confirmNewPassword": "Bekräfta nytt lösenord",
		"unsavedViewMsg2": "Dina ändringar kommer att gå förlorade om du inte sparar dem först.",
		"supportPortalErrorMessage": "Försök igen. Kontakta administratören om problemet kvarstår.",
		"legalText": "Licensed Materials - Property of IBM Corp. © Copyright IBM Corporation and other(s) 2005, %{year}. IBM, IBM-logotypen, ibm.com och Cognos är varumärken eller registrerade varumärken som tillhör International Business Machines Corp., registrerade i många jurisdiktioner världen över. En aktuell lista över varumärken som tillhör IBM finns på webbadressen www.ibm.com/legal/copytrade.shtml. Programmet licensieras enligt villkoren i det licensavtal som medföljer programmet.  Licensavtalet kan finnas i programkatalogen eller i ett bibliotek med namnet \"License\" eller \"Non_IBM_License\", eller tillhandahållas som ett licensavtal på papper. Läs avtalet noga innan du använder programmet. Du godkänner villkoren i och med att du använder programmet.",
		"groupsAndRoles": "Grupper och roller",
		"metricsMaintenanceTask": "Nytt underhåll",
		"email": "E-post",
		"contextual": "Kontext",
		"resetHome": "Återställ till standard",
		"ltr": "Vänster till höger",
		"credentials": "Kreditiv",
		"logging_congfig_title": "Loggning",
		"changePasswordTitle": "Byt lösenord",
		"format": "Rapportformat",
		"showUnread": "Visa olästa",
		"AILearning_active": "AI-inlärning är på:",
		"docsErrorMessage": "Försök igen. Kontakta administratören om problemet kvarstår.",
		"toggleEnabled": "på",
		"homeSetError": "Fel när standardhemsidan angavs. Försök stänga och öppna vyn igen.",
		"passwordChange": "Byt lösenord",
		"profile": "Profil",
		"pdfRestricted": "PDF (begränsat)",
		"drillThrough": "Genomborrningsdefinitioner",
		"homeSet": "Hemsida har angetts",
		"regionalOptions": "Nationella alternativ",
		"myPreferences": "Mina inställningar",
		"defaultHome": "Standard",
		"version": "Version",
		"controller": "Controller",
		"manage": "Hantera",
		"biDirectionalFeaturesEnabled": "Funktioner för dubbelriktade språk",
		"newFeaturesErrorTitle": "Länken till Nya funktioner fungerade inte",
		"passwordMatch": "Lösenordsmatchning",
		"updateProfileAndsettings": "Uppdatera profil och inställningar",
		"dashboardConsole": "Arbetsyta",
		"legacyAppsSlideoutLabel": "Tillgängliga äldre program",
		"logging_config_description": "Loggning används för felsökning. Be administratören om hjälp med inställningarna vid behov.",
		"confirmDeletion": "Bekräfta borttagning",
		"signInButtonText": "Logga in",
		"dataSourceCredentials": "Dataserverkreditiv",
		"AILearningConfigurationSlideoutAllyLabel": "Konfiguration av AI-inlärning",
		"loadingSettings": "Läser in inställningar",
		"spreadsheetMLRestricted": "Excel (begränsat)",
		"manageAILearning": "AI-inlärning",
		"xlsxDataRestricted": "Excel-data (begränsat)",
		"advanced": "Fler alternativ",
		"ok": "OK",
		"changeEmail": "Ändra",
		"showHints": "Visa tips",
		"general": "Allmänt",
		"xlsxData": "Excel-data",
		"newPassword": "Nytt lösenord",
		"hideAll": "Dölj alla",
		"confirmPassword": "Bekräfta lösenord",
		"AILearning_config_description": "Förbättra rekommendationer i produkten genom att låta Cognos Analytics få information om din användning.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "Länken till supportportalen fungerar inte",
		"log_level_Warn": "Varning",
		"contentSettings": "Innehållsinställningar",
		"setHomeButton": "Ange",
		"myCapabilities": "Mina befogenheter",
		"homePage": "Hemsida",
		"helpErrorMessage": "Försök igen. Kontakta administratören om problemet kvarstår.",
		"loadingProfile": "Läser in profil",
		"portal": "Portal",
		"metricsPackage": "Nytt paket",
		"myCredentials": "Mina kreditiv",
		"credentialCreate": "Skapa",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Det går inte att uppdatera lösenordet",
		"showHiddenObjects": "Visa dolda poster",
		"csv": "CSV",
		"docsErrorTitle": "Dokumentationslänken fungerar inte",
		"log_level_Error": "Fel",
		"wrongPassword": "Det går inte att autentisera",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Information",
		"welcomeBanner": "Välkomstbanderoll",
		"helpErrorTitle": "Hjälplänken fungerade inte",
		"contentLocale": "Innehållsspråk",
		"pdf": "PDF",
		"oldPassword": "Nuvarande lösenord",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Hjälpmedelsfunktioner",
		"manageLogging": "Loggning",
		"loggingConfigurationSlideoutA11yLabel": "Loggningsinställningar",
		"communityErrorTitle": "Gemenskapslänken fungerade inte",
		"companionApps": "Companion-program",
		"setHomeLabel": "Ange hemsida som (aktuell vy)",
		"metricsExportTask": "Ny export",
		"csvRestricted": "CSV (begränsat)",
		"newFeaturesErrorMessage": "Försök igen. Kontakta administratören om problemet kvarstår.",
		"contributor": "Contributor",
		"showAll": "Visa alla",
		"logging_active": "Loggning aktiverat:",
		"html": "HTML",
		"profileAndSettings": "Profil och inställningar",
		"baseTextDirection": "Basriktning för text",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Lösenord",
		"invalidEmail": "Ange en giltig e-postadress",
		"credentialCreateSuccess": "Du har skapat kreditiven",
		"settings": "Inställningar",
		"restrictedFormatSelected": "Du har inte befogenhet att köra rapporter i det här formatet men du kan använda rapporter som har sparats i det här formatet.",
		"usageDataDeletionConfirmation": "Om användningsdata tas bort återställs all AI-inlärning. Vill du ta bort användningsdata?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Visa detaljer",
		"deleteUsageData": "Ta bort användningsdata:",
		"showPassword": "Visa lösenord",
		"AILearning_config_title": "AI-inlärning",
		"myPreferencesSlideoutLabel": "Profil och inställningar",
		"passWordChangeSuccess": "Du har bytt lösenord",
		"logging_level": "Loggningsnivå:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Försök igen. Kontakta administratören om problemet kvarstår.",
		"cancel": "Avbryt",
		"shareSetError": "Det går inte att utföra åtgärden innan vyn har stängts och öppnats igen.",
		"passwordNotMatch": "Lösenorden matchar inte",
		"xml": "XML",
		"xmlRestricted": "XML (begränsat)",
		"openMenu": "Öppna meny",
		"closeMenu": 'Stäng meny'
});